module.exports = __webpack_public_path__ + "img/404.bcf54f63.jpg";